import { render, staticRenderFns } from "./OnboardedCustomers.vue?vue&type=template&id=d7e7bd6a"
import script from "./OnboardedCustomers.vue?vue&type=script&lang=js"
export * from "./OnboardedCustomers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports